import { motion } from "framer-motion";
import { MANIFESTO } from "@/data/business";

export const Manifesto = () => {
  return (
    <section id="why" data-testid="manifesto-section" className="bg-[#0D0D0D] border-y border-[#222222]">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-24 md:py-40">
        <span className="text-xs uppercase tracking-[0.2em] text-[#FF3B30] font-mono-plex font-bold">
          [ 02 — Why Manasa ]
        </span>

        <div className="mt-12">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.no}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`manifesto-${m.no}`}
              className="flex flex-col md:flex-row gap-6 md:gap-16 items-start border-t border-[#222222] py-12 md:py-16"
            >
              <span className="font-mono-plex font-bold text-[#222222] text-6xl md:text-8xl leading-none shrink-0 w-[2ch]">
                {m.no}
              </span>
              <div className="md:flex md:gap-16 md:flex-1">
                <h3 className="font-display font-bold text-white text-3xl md:text-5xl tracking-tight leading-[0.95] md:w-1/2 mb-4 md:mb-0">
                  {m.title}
                </h3>
                <p className="text-[#A0A0A0] text-sm md:text-base font-mono-plex leading-relaxed md:w-1/2 md:pt-2">
                  {m.desc}
                </p>
              </div>
            </motion.div>
          ))}
          <div className="border-t border-[#222222]" />
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
